export const RANDOM_BIG_NUMBER = 2147483647;